import styled from 'styled-components';

import valueHeroImage from '../../../assets/images/registration-goal-value-hero.png';

const Hero = styled.div.attrs({
  'data-ui': 'registration-goals-value-intro-hero',
})`
  width: ${({ theme }) => theme.scale.px(298)};
  height: ${({ theme }) => theme.scale.px(298)};
`;

const HeroImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

export function ValueIntroHero() {
  return (
    <Hero>
      <HeroImage alt="" aria-hidden src={valueHeroImage} />
    </Hero>
  );
}
